export const MOVIE_FILTERS = [
  { name: "Name", value: "original_title.asc" },
  { name: "Popularity", value: "popularity.desc" },
  // { id: 1, name: "Least Popular", value: "popularity.asc" },
  { name: "Release Date", value: "release_date.desc" },
  // { name: "Oldest", value: "release_date.asc" },
  { name: "Rating", value: "vote_average.desc" },
  // { id: 5, name: "Lowest Rating", value: "vote_average.asc" },
  // { value: "popularity.desc", name: "Popularity Descending" },
  // { value: "popularity.asc", name: "Popularity Ascending" },
  // { value: "vote_average.desc", name: "Rating Descending" },
  // { value: "vote_average.asc", name: "Rating Ascending" },
  // {
  //   value: "primary_release_date.desc",
  //   name: "Release Date Descending",
  // },
  // { value: "primary_release_date.asc", name: "Release Date Ascending" },
  // { value: "original_title.asc", name: "Title (A-Z)" },
];
